import React, { Component } from 'react'
import { connect } from 'react-redux';
import moment from 'moment';
import { Constants, Globals } from '../../../utils';

function parse(value) {
  return parseFloat(parseFloat(value).toFixed(2));
}

function getBillNumber(order) {
  const isFiscalBill = order?.fiscal_bill === Constants.ORDERS.FISCAL_BILL.YES;
  const isFiscalBillFree = order?.fiscal_bill_free === Constants.ORDERS.FISCAL_BILL_FREE.YES;

  return isFiscalBill
    ? order?.order_bill?.bill_number
    : (isFiscalBillFree ? order?.bill_number_format : '');
}

class ModalViewReturn extends Component {

  state = {
    returnedItem: this.props.returnedItem,
    exchangeRate: 0,
    totals: {
      subtotal_usd: 0,
      subtotal_bs: 0,
      paid_usd: 0,
      paid_bs: 0,
      left_usd: 0,
      left_bs: 0,
      total_bs: 0,
      total_usd: 0,
      change_bs: 0,
      change_usd: 0,
      iva_8_bs: 0,
      iva_8_usd: 0,
      iva_16_bs: 0,
      iva_16_usd: 0,
      iva_31_bs: 0,
      iva_31_usd: 0,
      iva_bs: 0,
      iva_usd: 0,
      igtf_bs: 0,
      igtf_usd: 0,
      discount_bs: 0,
      discount_usd: 0,
    },
    warehouses: [],
    methods: [],
  }

  componentDidMount() {
    this.formatOrder();
  }

  formatOrder = async () => {
    const formatProduct = (item) => {
      if (!item) return;

      if (item.product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
        const size_color = item.product.size_colors.find(sc => sc.id === item.size_color_id);

        if (!!size_color?.color) item.product.name += `, ${size_color.color.name}`;
        if (!!size_color?.size) item.product.name += `, ${size_color.size.name}`;
      }

      return {
        ...item,
        isFormatted: true,
        originalQuantity: item.quantity,
        quantity: String(item.quantity),
      }
    }

    const prods = this.props.returnedItem.details?.map(formatProduct);

    await this.setState(s => ({
      exchangeRate: parseFloat(this.state.returnedItem.conversion) || 0,
      returnedItem: {
        ...s.returnedItem,
        details: prods,
      },
    }));

    //this.setTotals();
  }

  setTotals = () => {
    const { returnedItem } = this.state;
    const exchangeRate = this.state.exchangeRate || 1;

    let subtotal_without_disc_usd = 0;
    let subtotal_without_disc_bs = 0;
    let subtotal_usd = 0;
    let subtotal_bs = 0;
    let left_usd = 0;
    let left_bs = 0;
    let total_bs = 0;
    let total_usd = 0;
    let change_bs = 0;
    let change_usd = 0;
    let iva_bs = 0;
    let iva_usd = 0;
    let iva_8_bs = 0;
    let iva_8_usd = 0;
    let iva_16_bs = 0;
    let iva_16_usd = 0;
    let iva_31_bs = 0;
    let iva_31_usd = 0;
    let igtf_bs = 0;
    let igtf_usd = 0;
    let total_taxes_usd = 0;
    let total_taxes_bs = 0;

    const products = [...returnedItem.details];

    const paymentMethods = returnedItem.order?.payment_methods ?? returnedItem.payment_methods ?? [];

    const paid_usd = parse(
      paymentMethods.reduce((acc, curr) => acc + Number(curr.amount || 0), 0)
    );
    const paid_bs = parse(
      paymentMethods.reduce((acc, curr) => acc + Number(curr.amount_bs || 0), 0)
    );

    // Paso 1: Calcular subtotales por producto
    for (const product of products) {
      const qty = product?.decimal_stock == Constants.DECIMAL_STOCK.YES
        ? parseFloat(product.quantity)
        : parseInt(product.quantity);

      const price = product?.price ?? product.sale_price;
      const subtotalWithoutDiscount = parse(qty * price);
      const discountPercentage = product.discount_percentage ?? product.discount;
      const discountAmount = discountPercentage > 0
        ? parse((subtotalWithoutDiscount * discountPercentage) / 100)
        : 0;

      // Calcular subtotal con descuento del producto
      const productSubtotal = discountPercentage > 0
        ? subtotalWithoutDiscount - discountAmount
        : subtotalWithoutDiscount;

      // Guardar en el producto
      product.subtotalWithoutTaxes = productSubtotal;
      product.subtotal = productSubtotal;
      subtotal_usd += productSubtotal;

      // Calcular IVA si el producto no es exento
      if (product?.product?.exento == Constants.PRODUCT_EXENTO.NO) {
        const ivaPercentage = product?.product?.iva_porcentage ?? 0;
        const iva_product = parse((productSubtotal * ivaPercentage) / 100);

        // Acumular IVA
        iva_usd += iva_product;
        product.iva_usd = iva_product;

        // Acumular por categoría de IVA
        const iva = product?.product?.iva ?? product.iva;
        if (iva === Constants.PRODUCT_IVA.DIECISEIZ) {
          iva_16_usd += iva_product;
        } else if (iva === Constants.PRODUCT_IVA.OCHO) {
          iva_8_usd += iva_product;
        } else if (iva === Constants.PRODUCT_IVA.TREINTAIUNO) {
          iva_31_usd += iva_product;
        }

        // ¡IMPORTANTE! Sumar el IVA al subtotal del producto
        // Esto es lo que se hace en la creación de pedidos
        product.subtotal = parse(productSubtotal + iva_product);
      }

      product.discount = discountAmount;
      product.total = product.subtotal; // total ahora incluye IVA si aplica
    }

    // Paso 2: Aplicar descuento global
    const discountAmountGlobal = returnedItem.discount_percentage > 0
      ? parse((subtotal_usd * returnedItem.discount_percentage) / 100)
      : 0;

    subtotal_without_disc_usd = subtotal_usd;
    subtotal_usd = returnedItem.discount_percentage > 0
      ? subtotal_usd - discountAmountGlobal
      : subtotal_usd;

    // Aplicar descuento proporcional al IVA
    const ivaDiscountAmount = returnedItem.discount_percentage > 0
      ? parse((iva_usd * returnedItem.discount_percentage) / 100)
      : 0;

    iva_usd = returnedItem.discount_percentage > 0
      ? iva_usd - ivaDiscountAmount
      : iva_usd;

    // Paso 3: Conversión a BS
    subtotal_without_disc_bs = parse(subtotal_without_disc_usd * exchangeRate);
    subtotal_bs = parse(subtotal_usd * exchangeRate);
    iva_bs = parse(iva_usd * exchangeRate);
    iva_8_bs = parse(iva_8_usd * exchangeRate);
    iva_16_bs = parse(iva_16_usd * exchangeRate);
    iva_31_bs = parse(iva_31_usd * exchangeRate);

    total_taxes_usd = parse(iva_usd);
    total_taxes_bs = iva_bs;

    // Paso 4: Calcular total
    total_usd = parse(subtotal_usd + total_taxes_usd);

    // Paso 5: Calcular IGTF
    const hasIGTF = paymentMethods.some(method =>
      !Constants.LOCAL_CURRENCIES.includes(method.method_id)
    );

    if (hasIGTF) {
      igtf_usd = parse((total_usd * Constants.TAXES.IGTF) / 100);
      igtf_bs = parse(igtf_usd * exchangeRate);
      total_usd = parse(total_usd + igtf_usd);
    }

    total_bs = parse(total_usd * exchangeRate);

    // Paso 6: Calcular saldos y cambios
    left_usd = parse(total_usd - paid_usd);
    left_bs = parse(total_bs - paid_bs);

    if (left_usd < 0) {
      change_usd = parse(Math.abs(left_usd));
      change_bs = parse(change_usd * exchangeRate);
      left_usd = 0;
      left_bs = 0;
    }

    const totals = {
      subtotal_without_disc_usd,
      subtotal_without_disc_bs,
      subtotal_usd,
      subtotal_bs,
      paid_usd,
      paid_bs,
      left_usd,
      left_bs,
      total_bs,
      total_usd,
      change_bs,
      change_usd,
      iva_bs,
      iva_usd,
      iva_8_bs,
      iva_8_usd,
      iva_16_bs,
      iva_16_usd,
      iva_31_bs,
      iva_31_usd,
      igtf_bs,
      igtf_usd,
      discount_bs: parse(discountAmountGlobal * exchangeRate),
      discount_usd: parse(discountAmountGlobal),
    };

    this.setState(s => ({
      returnedItem: {
        ...s.returnedItem,
        details: products,
        subtotal: subtotal_usd,
        discount: discountAmountGlobal,
        iva: iva_usd,
        igtf: igtf_usd,
        total: total_usd,
      },
      totals,
    }));
  }

  convert = (value) => {
    return value * (this.state.exchangeRate || 0);
  }

  render() {

    const { returnedItem, totals } = this.state;

    return (
      <>
        <div className="modal-top">
          <div>
            <p>Cliente: {returnedItem?.order?.client?.name}</p>
            <p>Cédula: {returnedItem?.order?.client?.document}</p>
            <p className="conversion">Tasa de cambio: Bs. {Globals.newFormatMiles(this.state.exchangeRate || 0, 4)}</p>
          </div>
          <div>
            <p className="date">Fecha de emisión factura: {moment(returnedItem?.created_at).format('DD/MM/YYYY HH:mm')}</p>
            <p>Forma de pago factura: {returnedItem?.payment_methods_text}</p>
            <p className="date">Fecha de emisión nota de crédito: {moment(returnedItem?.return?.created_at).format('DD/MM/YYYY HH:mm')}</p>
            <p>N° Nota de Crédito: {returnedItem?.number_format}</p>
          </div>
        </div>

        <table border={1}>
          <thead>
            <tr>
              <td>Código</td>
              <td>Descripción</td>
              <td>Cantidad</td>
              <td>Precio</td>
              <td>Desc %</td>
              <td>Neto</td>
            </tr>
          </thead>
          <tbody>
            {returnedItem?.details?.map((item, index) => (
              <tr key={index}>
                <td>{item.product?.code}</td>
                <td>{item.product?.name}</td>
                <td align="center">{item.quantity}</td>
                <td align="right">Bs. {Globals.formatMiles(this.convert(item.price))}</td>
                <td>{item.discount_percentage}</td>
                <td align="right">Bs. {Globals.formatMiles(this.convert(item.total))}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="modal-bottom">
          <div>
            <div className="table-footer">
              <div className="date">
                <label>Fecha</label>
                <span>{moment(returnedItem.created_at).format('DD-MM-YYYY')}</span>
              </div>
              <div className="date">
                <label>Motivo de nota de débito</label>
                <span>{returnedItem?.motive || '-'}</span>
              </div>
            </div>

            <div className="table-footer">
              <div className="date">
                <label>Número de Factura</label>
                <span>{getBillNumber(returnedItem?.order) || '-'}</span>
              </div>
              <div className="date">
                <label>Método de pago</label>
                <span>{returnedItem?.payment_methods_text || '-'}</span>
              </div>
            </div>
          </div>

          <div className="totals">
            <div>
              <span>Sub-total</span>
              <span>Bs. {Globals.formatMiles(this.convert(returnedItem?.subtotal || 0))}</span>
            </div>
            <div>
              <span>% Desc</span>
              <span>
                <span>({Globals.formatMiles(returnedItem?.discount_percentage)}%) </span>
                <span>-Bs. {Globals.formatMiles(this.convert(returnedItem?.discount || 0))}</span>
              </span>
            </div>
            <div>
              <span>IVA</span>
              <span>Bs. {Globals.formatMiles(returnedItem?.iva_bs || 0)}</span>
            </div>
            {returnedItem?.igtf_bs > 0 && (
              <div>
                <span>IGTF</span>
                <span>Bs. {Globals.formatMiles(returnedItem?.igtf_bs || 0)}</span>
              </div>
            )}
            <div>
              <span>Total</span>
              <span>Bs. {Globals.formatMiles(this.convert(returnedItem?.total))}</span>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default connect(state => ({
  user: state.user,
}))(ModalViewReturn);